module.exports = __webpack_public_path__ + "static/i2-6cf4d0ec23c44b205e86f6c0b9c3661e.jpg";